import { SDKModel } from '../../core/model.js';
import { registerComponent, normalizeOptions } from '@sitecore/byoc';
import { getEmbedDefinition } from '../../index.js';
import { DatasourceModel } from '../datasources.js';
class ExternalComponentModel extends SDKModel {
    /** Get settings for all datasoruces used in component */
    getDataSettings() {
        return DatasourceModel.getSettingsFromDatasources(this.datasourceIds, this.sdk.datasources);
    }
    /** We consider that components that come from @sitecore/components package will have a name with the "Sitecore" prefix */
    isSitecoreComponent() {
        return !!this.name.startsWith('Sitecore');
    }
    getImportStatement() {
        var _a, _b, _c, _d, _e;
        if ((_a = this.meta) === null || _a === void 0 ? void 0 : _a.importStatement)
            return (_b = this.meta) === null || _b === void 0 ? void 0 : _b.importStatement;
        else if (this.isSitecoreComponent())
            return ((_c = this.links) === null || _c === void 0 ? void 0 : _c.github)
                ? `import @sitecore/components/${this.links.github.substring(this.links.github.lastIndexOf('/') + 1)}`
                : null;
        else if ((_d = this.links) === null || _d === void 0 ? void 0 : _d.npm)
            return `import ${(_e = this.links) === null || _e === void 0 ? void 0 : _e.npm.replace('https://www.npmjs.com/package/', '')}`;
        else
            return null;
    }
    static getDefinition(context) {
        return getEmbedDefinition(context);
    }
    static loadFromSessionStorage() {
        return JSON.parse(sessionStorage.getItem('feaas-external-components'));
    }
    static storeToSessionStorage(components) {
        if (typeof sessionStorage != 'undefined')
            sessionStorage.setItem('feaas-external-components', JSON.stringify(components));
    }
    static setComponents(components) {
        this.components = components;
    }
    static setForms(forms) {
        this.forms = forms;
    }
    static updateComponents(collection, expandedCollection, expandedList = this.getExpandedComponents(), components = this.components || []) {
        collection.setItems(components);
        expandedCollection.setItems(expandedList);
        this.storeToSessionStorage(expandedList);
        expandedList.map((c) => registerComponent(c.component, c));
    }
    static getExpandedComponents() {
        //   if (!this.components) return []
        var components = (this.components || []).filter((c) => !c.isHidden);
        if (this.forms) {
            ExternalComponentModel.isFormsEnabled || (ExternalComponentModel.isFormsEnabled = (this.components || []).some((c) => c.name == 'SitecoreForm'));
            if (ExternalComponentModel.isFormsEnabled) {
                components = components
                    .filter((c) => !ExternalComponentModel.isComponentForm(c))
                    .concat(this.forms.map((form) => normalizeOptions({
                    ...form,
                    id: 'SitecoreForm?formId=' + form.id,
                    name: 'SitecoreForm',
                    title: form.name,
                    group: 'Forms',
                    isHidden: false
                }, null)));
            }
        }
        return components;
    }
    static isComponentForm(component) {
        return component && component.name == 'SitecoreForm';
    }
    static isExternalComponent(component) {
        return component && 'schema' in component;
    }
}
// combine components & forms
ExternalComponentModel.isFormsEnabled = false;
export { ExternalComponentModel };
//# sourceMappingURL=external-components.js.map